import {
  Card,
  CardHeader,
  createTheme,
  Grid,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableRow,
} from "@material-ui/core";
import PropTypes from "prop-types";
import { useMemo, useState } from "react";
import { TablaHead, TablaToolbar } from "../_dashboard/tablas";
import Scrollbar from "../Scrollbar";
import SearchNotFound from "../SearchNotFound";
import { ThemeProvider } from "@material-ui/styles";
import * as locales from "@material-ui/core/locale";
import CustomTablePagination from "../CustomTablePagination";
import { applySortFilter, getComparator } from "src/utils/sharedTables";
import RowAppClient from "./row-app-client";

AppTablaDetalleDistribucionClientes.propTypes = {
  rows: PropTypes.array,
  title: PropTypes.string,
  subheader: PropTypes.string,
  loading: PropTypes.bool,
};

const TABLE_HEAD = [
  { id: "action", label: "", alignRight: false },
  { id: "rut", label: "RUT", alignRight: false },
  { id: "cliente", label: "Cliente", alignRight: false },
  { id: "fechaIngreso", label: "Fecha ingreso", alignRight: false },
];

const INITIAL_STATE_TABLE = {
  currentPage: 0,
  rowsPerPageOptions: 5,
  order: "asc",
  orderBy: "cliente",
  locale: "esES",
  filterName: "",
};

export default function AppTablaDetalleDistribucionClientes({
  rows,
  title,
  subheader,
  loading = false,
}) {
  const [state, setState] = useState(INITIAL_STATE_TABLE);

  const handleFilterByName = (event) => {
    setState({ ...state, filterName: event.target.value });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = state.orderBy === property && state.order === "asc";
    setState({ ...state, order: isAsc ? "desc" : "asc", orderBy: property });
  };

  const filasFiltradas = useMemo(() => {
    const propiedadesParaFiltrar = ["cliente", "rut"];
    return applySortFilter(
      rows,
      getComparator(state.order, state.orderBy),
      state.filterName,
      propiedadesParaFiltrar,
    );
  }, [rows, state.filterName, state.order, state.orderBy]);

  const emptyRows =
    state.currentPage > 0
      ? Math.max(
          0,
          (1 + state.currentPage) * state.rowsPerPageOptions - rows.length,
        )
      : 0;

  const esSucursalNoEncontrada = filasFiltradas.length === 0;

  const handleChangePage = (event, newPage) => {
    setState({ ...state, currentPage: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setState({
      ...state,
      rowsPerPageOptions: Number(event.target.value),
      currentPage: 0,
    });
  };

  return (
    <Card sx={{ height: "100%" }}>
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="stretch"
        sx={{ height: "100%" }}
      >
        <Grid item>
          <Grid container>
            <Grid item xs={12} md={6} lg={6}>
              <CardHeader title={title} subheader={subheader} />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Grid container justifyContent="flex-end" alignItems="center">
                <Grid item></Grid>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                  xs={12}
                  md={8}
                  lg={8}
                >
                  <TablaToolbar
                    filterName={state.filterName}
                    onFilterName={handleFilterByName}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Scrollbar sx={{ height: "100%" }}>
            <TableContainer component={Paper}>
              {!loading ? (
                <Table aria-label="collapsible table">
                  <TablaHead
                    order={state.order}
                    orderBy={state.orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={rows?.length}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {filasFiltradas
                      .slice(
                        state.currentPage * state.rowsPerPageOptions,
                        state.currentPage * state.rowsPerPageOptions +
                          state.rowsPerPageOptions,
                      )
                      .map((row, index) => (
                        <RowAppClient key={index} row={row} />
                      ))}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={7} />
                      </TableRow>
                    )}
                  </TableBody>
                  {esSucursalNoEncontrada && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={state.filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                  <TableFooter>
                    <TableRow>
                      <ThemeProvider
                        theme={(outerTheme) =>
                          createTheme(outerTheme, locales[state.locale])
                        }
                      >
                        <CustomTablePagination
                          count={filasFiltradas.length}
                          rowsPerPage={state.rowsPerPageOptions}
                          page={state.currentPage}
                          colSpan={9}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </ThemeProvider>
                    </TableRow>
                  </TableFooter>
                </Table>
              ) : (
                <Skeleton variant="rectangular" width="100%" height="500px" />
              )}
            </TableContainer>
          </Scrollbar>
        </Grid>
      </Grid>
    </Card>
  );
}
